import { useAppContext } from '@/contexts/AppContext';
import { APP_PERMISSIONS } from '@/services/roleService';
import React from 'react';

const useHasPermissions = (permissions: Array<string | null | undefined>) => {
  const { auth } = useAppContext();
  const hasPermissions = React.useMemo(() => {
    return permissions.some(x => auth?.permissions?.includes(x as any));
  }, [auth, permissions]);

  return hasPermissions;
};
export default useHasPermissions;

export const useCanManageFleetTrip = () => useHasPermissions([APP_PERMISSIONS.ManageFleetsTrips]);
export const useCanManageTicketTariff = () => useHasPermissions([APP_PERMISSIONS.ManageTicketTariffs]);
export const useCanManageBaggageTariff = () => useHasPermissions([APP_PERMISSIONS.ManageBaggageTariffs]);
